<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <v-container :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'">
    <div class="d-flex align-center">
      <back-button @close-event="closeDialog" />
      <page-header class="py-4 pb-6">
        {{ $t('buffetPrice') }}
      </page-header>
    </div>
    <div class="mt-4">
      <template v-if="priceDishes.length>0">
        <v-card
          v-for="(bp,index) in priceDishes"
          :key="bp.id"
          class="pa-4 d-flex align-center mb-2"
          outlined
        >
          <div>
            {{ bp.code }}.{{ bp.name }}
          </div>

          <v-spacer />
          <v-chip
            class="mr-2"
            small
          >
            {{ bp.isForAdult ? $t('adult') : $t('kid') }}
          </v-chip>
          <div class="mr-4">
            {{ bp.price|priceDisplay }}
          </div>
          <v-menu
            close-on-content-click
            left
            offset-overflow
            offset-y
            rounded
          >
            <template #activator="{on,attrs}">
              <v-btn
                icon
                outlined
                style="border-radius: 12px"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list
              outlined
              width="200px"
            >
              <v-list-item-group>
                <v-list-item @click="editItem(index)">
                  <v-list-item-title>{{ $t('open') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteItem(bp.id)">
                  <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-card>
      </template>
      <template v-else>
        <v-card
          class="pa-4 py-6"
          outlined
        >
          {{ $t('noPriceClickAdd') }}
        </v-card>
      </template>
    </div>
    <template v-if="$vuetify.breakpoint.lgAndUp">
      <v-btn
        class="mt-4"
        color="amber lighten-4 black--text"
        elevation="0"
        @click="editItem(-1)"
      >
        {{ $t('newDinnerPrice') }}
      </v-btn>
      <v-btn
        class="mt-4 ml-4"
        color="info lighten-4 black--text"
        elevation="0"
        @click="bindItem()"
      >
        {{ $t('Bind') }}
      </v-btn>
    </template>
    <template v-else>
      <fab-button
        background="blue"
        color="white"
        fab-bottom
        fab-fixed
        fab-right
        icon="mdi-plus"
        @click-event="editItem(-1)"
      />
    </template>
    <ik-entity-form
      v-model="showDialog"
      :edited-index="activeIndex"
      :model="model"
      :out-side-list="priceDishes"
      :out-side-property="{consumeTypeId : consumeTypeId}"
      :title="$t('price')"
      @need-refresh="getCurrentPriceDishes"
    />
    <v-dialog
      v-model="dishesDialog"
      max-width="500px"
    >
      <v-card class="pa-4">
        <page-sub-header>{{ $t('price') }}</page-sub-header>
        <loading-provider :loading="loading">
          <v-select
            v-model="selectedDish"
            :items="allBuffetPriceDishes"
            item-text="dishName"
            return-object
            :label="$t('price')"
          />
          <v-select
            v-model="isForAdult"
            :items="[{text:$t('yes'),value:1},{text:$t('no'),value:0}]"
            item-text="text"
            item-value="value"
            :label="$t('isForAdult')"
          />
          <div class="d-flex align-center">
            <div />
            <v-spacer />
            <v-btn
              class="mr-2"
              elevation="0"
              color="info"
              @click="dishesDialog = false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              elevation="0"
              color="primary"
              @click="confirmBind"
            >
              {{ $t('confirm') }}
            </v-btn>
          </div>
        </loading-provider>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader'
import BuffetPrice, { bindDishesByBuffetPrice } from '@/model/dataLayer/api/buffet/BuffetPrice'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'
import { showSuccessMessage, sureToDelete } from '@/model/utils/utils'
import IKUtils from 'innerken-js-utils'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import FabButton from '@/views/AadenPages/components/FabButton/FabButton'
import Dish from '@/model/dataLayer/api/dish/Dish'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'

export default {
  name: 'BuffetPriceDishFragment',
  components: {
    PageSubHeader,
    LoadingProvider,
    PageHeader,
    IkEntityForm,
    BackButton,
    FabButton
  },
  props: {
    consumeTypeId: {}
  },
  data: function () {
    return {
      isForAdult: 1,
      loading: false,
      dishesDialog: false,
      model: BuffetPrice,
      showDialog: null,
      priceDishes: [],
      activeIndex: -1,
      allBuffetPriceDishes: [],
      selectedDish: null
    }
  },
  watch: {
    async consumeTypeId (val) {
      await this.getCurrentPriceDishes()
    }
  },
  mounted () {
    this.getCurrentPriceDishes()
  },
  methods: {
    async bindItem () {
      this.selectedDish = null
      this.dishesDialog = true
      this.loading = true
      this.allBuffetPriceDishes = await Dish.getBuffet()
      this.loading = false
      console.log(this.allBuffetPriceDishes, 'all1')
    },
    async confirmBind () {
      if (!this.selectedDish) {
        return
      }
      IKUtils.showLoading()
      this.selectedDish.isForAdult = this.isForAdult
      await bindDishesByBuffetPrice(this.selectedDish, this.consumeTypeId)
      await this.getCurrentPriceDishes()
      this.dishesDialog = false
      showSuccessMessage('Success')
    },
    editItem (index) {
      this.activeIndex = index
      this.showDialog = true
    },
    async deleteItem (id) {
      await sureToDelete(async () => {
        IKUtils.showLoading()
        await this.model.remove(id)
        await this.getCurrentPriceDishes()
        showSuccessMessage()
      })
    },
    async closeDialog () {
      this.$emit('close-dialog')
    },
    async getCurrentPriceDishes () {
      try {
        this.priceDishes = await BuffetPrice.getList(true, { consumeTypeId: this.consumeTypeId ?? 1 })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
